import { render, staticRenderFns } from "./rijbewijs-de.vue?vue&type=template&id=3949536a"
import script from "./rijbewijs-de.vue?vue&type=script&lang=js"
export * from "./rijbewijs-de.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports